export enum WebchatConfigurationKeys {
  APP_INSIGHTS_CONNECTION_STRING = 'appInsightsConnectionString',
  GOOGLE_TAG_MANAGER_KEY = 'googleTagManagerKey',
}

export interface WebchatConfiguration {
  [WebchatConfigurationKeys.APP_INSIGHTS_CONNECTION_STRING]: string;
  [WebchatConfigurationKeys.GOOGLE_TAG_MANAGER_KEY]: string;
}
